<template>
    <div
        class="
            flex flex-row
            justify-start
            items-center
            px-6
            h-20
            hover:bg-primary-lightest
            transition-all
            cursor-pointer
        "
        :class="
            GET_SLIDE && GET_SLIDE.id == slide.id
                ? 'bg-primary-lightest'
                : 'bg-white'
        "
        @click="SET_SLIDE"
    >
        <div class="h-full pt-4 mr-2">
            <input-checkbox
                class="w-8"
                :name="``"
                :id="`${slide.name}-${slide.id}`"
                :modelValue="slide.progress.is_finished ?? false"
                :defaultColor="'grey'"
                :activeColor="'primary'"
            />
        </div>
        <div style="width: calc(100% - 50px)">
            <div
                class="
                    w-full
                    text-black
                    overflow-ellipsis overflow-hidden
                    whitespace-nowrap
                    select-none
                    mt-1
                "
            >
                {{ slide.name }}
            </div>
            <div class="w-full flex flex-row justify-start items-center mt-2">
                <my-course-icon
                    :fillClass="'fill-primary'"
                    class="h-3 w-3 mr-2"
                    v-if="slide.type != 'video'"
                />
                <arrow-icon
                    v-else
                    :fillClass="'fill-primary'"
                    class="transform -rotate-90 mr-1"
                />
                <div
                    style="width: calc(100% - 30px)"
                    class="
                        text-grey text-sm
                        overflow-ellipsis overflow-hidden
                        whitespace-nowrap
                        select-none
                    "
                >
                    {{ `${slide.minutes} Min.` }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, defineComponent, reactive } from "@vue/runtime-core";
import { useStore } from "vuex";
import MyCourseIcon from "../../../components/icons/MyCourseIcon.vue";
import InputCheckbox from "../../../components/input/InputCheckbox.vue";
import { COURSE_TYPES, SLIDE_TYPES, STORE_TYPES } from "../../../store/types";

export default defineComponent({
    name: "SlideCard",
    components: { InputCheckbox, MyCourseIcon },
    emits: ["select"],
    props: {
        slide: { required: true },
        index: { type: Number, required: true },
    },
    setup(props) {
        const store = useStore();
        /**
         *  State
         */
        const state = reactive({});
        /**
         *  Functions
         */
        function SET_SLIDE() {
            // Set "showMaterials" = false so the click on the course always navigates to the corresponding course section / slide
            store.commit(
                `${STORE_TYPES.COURSES}/${COURSE_TYPES.SET_SHOW_DOCUMENTS}`,
                false
            );
            if (!GET_SLIDE.value || GET_SLIDE.value.id != props.slide.id) {
                store.commit(
                    `${STORE_TYPES.SLIDES}/${SLIDE_TYPES.SET_SLIDE}`,
                    null
                );
                store.commit(
                    `${STORE_TYPES.COURSES}/${COURSE_TYPES.SET_SELECTED_COURSE_TYPE}`,
                    null
                );
                setTimeout(() => {
                    store.commit(
                        `${STORE_TYPES.COURSES}/${COURSE_TYPES.SET_SELECTED_COURSE_TYPE}`,
                        "slide"
                    );
                    store.commit(
                        `${STORE_TYPES.SLIDES}/${SLIDE_TYPES.SET_SLIDE}`,
                        props.slide
                    );
                }, 100);
            }
            scrollToTop();
        }
        function scrollToTop() {
            const scrollBox = document.getElementById("course-main");
            if (scrollBox) {
                scrollBox.scrollIntoView({ behavior: "smooth" });
            }
        }
        /**
         *  Computed
         */
        const GET_COURSE = computed(
            () =>
                store.getters[
                    `${STORE_TYPES.COURSES}/${COURSE_TYPES.GET_COURSE}`
                ]
        );
        const GET_SLIDE = computed(
            () =>
                store.getters[`${STORE_TYPES.SLIDES}/${SLIDE_TYPES.GET_SLIDE}`]
        );

        /**
         *  Created
         */

        return { state, SET_SLIDE, GET_COURSE, GET_SLIDE };
    },
});
</script>
